import React, { useMemo, useState } from 'react';
import { useGetAllDisbursements } from '../edit/useGetDisbursementsForSettlementItem';
import { DisbursementsModal } from './DisbursementsModal';
import { useListAdminStandardDocumentsQuery } from 'API/order/documents/DocumentApi';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from 'API/documentCategories/DocumentCategoriesApi';
import { useDisburseAllMutation } from 'API/order/escrow/EscrowBaseAPI';
import { disbursementByType } from '../edit/disbursements/disbursementsByType';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { assertDefined } from 'utilities/Assertions';
import { IDisburseAllRequest } from 'types/order/escrow/IDisburseAllRequest';
import { IDisburseAllResult } from 'types/order/escrow/IDisburseAllResult';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { DisbursementResults } from './DisbursementResults';

export interface IDisburseAllContainerProps {}

export const DisburseAllContainer: React.FC<IDisburseAllContainerProps> = () => {
  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);

  const [disburseAllMutation, { isLoading }] = useDisburseAllMutation();
  const [disburseResults, setDisburseResults] = useState<IDisburseAllResult>();
  const disbursements = useGetAllDisbursements({ orderId });

  const eligibleDisbursements = useMemo(
    () =>
      disbursements.filter(
        (t) => !disbursementByType[t.disbursement.type].isReadOnly(t.disbursement) && !t.disbursement.holdback
      ),
    [disbursements]
  );

  const { data: documents, isLoading: isLoadingDocuments } = useListAdminStandardDocumentsQuery({ orderId });
  const { data: { activeCategories } = defaultNormalizedDocumentCategoriesData } = useListDocumentCategoriesQuery();

  const onDisburseAll = async (x: IDisburseAllRequest) => {
    const result = await disburseAllMutation(x);
    if (checkForMutationSuccess(result, 'disburse all')) {
      setDisburseResults(result.data);
    }
  };

  return (
    <>
      {!disburseResults && (
        <DisbursementsModal
          orderId={orderId}
          activeCategories={activeCategories}
          disbursements={eligibleDisbursements}
          documentsList={documents ?? []}
          isLoadingDocuments={isLoadingDocuments}
          onDisburseAll={onDisburseAll}
          disburseAllIsLoading={isLoading}
        />
      )}
      {!!disburseResults && (
        <DisbursementResults orderId={orderId} results={disburseResults} disbursements={disbursements} />
      )}
    </>
  );
};
